'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/~/history/lib/ExecutionEnvironment.js
 ** module id = 590
 ** module chunks = 23
 **/